import React, { useEffect, useState, useCallback } from "react";
import { Container, Row, Col } from "react-grid-system";
import { useSelector } from "react-redux";
import { setPrice } from "../../../server/Product";
import { GetPromotions } from "../../../server/PriceList";
import FamilyChangeDialog from "./FamilyChangeDialog";
import "./ComparePricePopUp.scss";
import PricesCompareTable from "./PricesCompareTable";
import Promotion from "./Promotion";
import PopUp from "../../../components/containers/PopUp";

const ComparePricePopUp = ({ product, setComparePricePopUp }) => {
  const [keepProfitMargin, setKeepProfitMargin] = useState(false);
  const [sellingPrice, setSellingPrice] = useState("");
  const [showPricePopUp, setShowPricePopUp] = useState(false);
  const [showPromotionPopUp, setShowPromotionPopUp] = useState(false);
  const [promotions, setPromotions] = useState([]);

  const { stationId, selectedProduct, pricing, categories } = useSelector(
    (state) => ({
      stationId: state.user.stationId,
      selectedProduct: state.selectedProduct.product,
      pricing: state.selectedProduct.productPricing,
      categories: state.selectedProduct.productCategories,
    }),
  );

  if (!product && selectedProduct) {
    product = selectedProduct;
  }

  useEffect(() => {
    if (pricing?.Product !== undefined) {
      setSellingPrice(pricing.Product.price);
    }
    return () => {
      if (setComparePricePopUp) {
        setComparePricePopUp();
      }
    };
  }, [pricing, setComparePricePopUp]);

  const handleSellingPriceChange = (value) => {
    setSellingPrice(value);
  };

  const fetchPromotions = useCallback(() => {
    if (!product?.gtin || !stationId) return;

    GetPromotions({ gtin: product.gtin, branch: stationId })
      .then((data) => setPromotions(data || []))
      .catch(() => console.log("error"));
  }, [product, stationId]);

  useEffect(() => {
    fetchPromotions();
  }, [fetchPromotions]);

  const changePrice = async (productsToChange) => {
    try {
      await Promise.all(
        productsToChange.map(async (prod) => {
          await setPrice(stationId, prod.gtin, sellingPrice);
        }),
      );
    } catch (error) {
      console.error("Error updating prices:", error);
    }
  };

  const handleSellingPriceBlur = () => {
    if (pricing?.Product?.price !== sellingPrice && sellingPrice !== "") {
      if (categories[0].isFamily) setShowPricePopUp(true);
      else changePrice([product], sellingPrice);
    }
  };

  return (
    <>
      <Container fluid className="compare-price-container">
        <Row className="main-row">
          <Col sm={2}>
            <button
              className="create-promo-btn"
              onClick={() => setShowPromotionPopUp(true)}
            >
              יצירת מבצע חדש
            </button>
            <div className="section-card">
              <h3 className="section-title">מחירים</h3>
              <Row>
                <Col sm={12}>
                  <div className="field-group">
                    <label className="field-label">מחיר קנייה</label>
                    <input
                      type="number"
                      step="0.01"
                      className="number-input"
                      placeholder="0.00"
                    />
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="field-group">
                    <label className="field-label">מחיר מכירה</label>
                    <input
                      type="number"
                      step="0.01"
                      value={sellingPrice}
                      onChange={(e) => handleSellingPriceChange(e.target.value)}
                      onBlur={handleSellingPriceBlur}
                      className="number-input"
                      placeholder="0.00"
                    />
                    <div className="checkbox-wrapper">
                      <input
                        type="checkbox"
                        id="keepMargin"
                        checked={keepProfitMargin}
                        onChange={() => setKeepProfitMargin(!keepProfitMargin)}
                      />
                      <label htmlFor="keepMargin">שמור רווח</label>
                    </div>
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="field-group">
                    <label className="field-label">אחוז רווח</label>
                    <input
                      type="number"
                      step="0.01"
                      className="number-input"
                      placeholder="0.00"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col sm={promotions.length > 0 ? 2 : 5}>
            <PricesCompareTable selectedProd={product} />
          </Col>
          <Col sm={10}>
            <Row className="promotions-row">
              {promotions.length > 0 &&
                promotions.map((promo) => (
                  <Col sm={6} key={promo.id}>
                    <Promotion promo={promo} product={product} />
                  </Col>
                ))}
              {showPromotionPopUp && (
                <PopUp width="850px" close={() => setShowPromotionPopUp(false)}>
                  <Promotion
                    product={product}
                    close={() => setShowPromotionPopUp(false)}
                    onCreated={fetchPromotions}
                  />
                </PopUp>
              )}
            </Row>
          </Col>
        </Row>
      </Container>

      {showPricePopUp && (
        <FamilyChangeDialog
          product={product}
          close={setShowPricePopUp}
          onConfirm={changePrice}
          markedProducts={[product]}
          massage={"סמן את המוצרים שתרצה לשנות בנוסף אליו:"}
          slug={categories[0].slug}
        />
      )}
    </>
  );
};

export default ComparePricePopUp;
